<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯牵手安阳，人机协同助力甲骨文“破译”与传承活化</div>
      <div class="news-date">2022年12月10日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>在中国考古学界流传一句话，“没有哪处遗址的重要性超过殷墟”。</p>
        <p>这座中国连续发掘时间最长、清理遗迹最多、出土文物最丰富的古遗址，今天已不仅仅意味着一座商代都城的旧址，更是中华文明探源最为关键的节点之一，世界范围内公认的人类早期文明重要遗存。</p>
        <p>更令人惊叹的是，殷墟也是一座“历久弥新”的遗址，时至今日仍不断有新发现，讲述一个又一个引人入胜的文明源流故事。</p>
        <br>
        <div class="news-content-mark">
          <h2>1. 中国信史得以向前推进千年</h2>
        </div>
        <p>
          <span class="mark-text">今天考古学界的共识是，殷墟出土的极为丰富的文物中，甲骨是分量最重的一类。</span>
          作为形成期中华文明最重要的见证，甲骨文自初次发现120余年以来，在中国大地上最重要的出土之所还是殷墟。
        </p>
        <p>安阳殷墟较大规模出土甲骨文迄今共有3次，即1936年发掘小屯村北YH127甲骨窖穴，1973年发掘小屯村南地甲骨窖穴，1991年发掘洹南花园庄东地H3甲骨窖穴，合称“甲骨文三次大发现”。到目前，殷墟出土16万多片甲骨，发现单字约4500字，已释读约1500字。正是有了甲骨文的凭证，中国信史得以向前推进了约1000年。</p>
        <br>
        <div class="news-content-mark">
          <h2>2. 面临三大问题</h2>
        </div>
        <p>今天，甲骨研究已经成为多学科协同攻关的一门人文科学，甲骨上的笔划和微痕得以精密分析，甲骨文的释读成果有了完备的数据库。作为认知中国早期历史和古代文明的重要门径，甲骨学已经成为一门世界性学科。</p>
        <p>在甲骨文考释研究与传承活化上，面临三个问题需要突破。</p>
        <p>
          <span class="mark-text">第一，已经发现的约4500个甲骨字，其中约3000字尚未释读，</span>
          甲骨文专家学者数量少，急需智能工具帮助提升字形匹配的搜索效率、推荐破译的相关线索；
        </p>
        <p>
          <span class="mark-text">第二，甲骨文作为冷门绝学，与公众的距离很远，</span>
          而甲骨文蕴含着丰富的造字智慧和文化价值，急需将冷门的文化资源转化成大家喜闻乐见愿意参与的普惠文化服务；
        </p>
        <p>
          <span class="mark-text">第三，甲骨文活化利用的素材有限、手段传统、较为分散，急需系统化开展工作。</span>
        </p>
        <br>
        <div class="news-content-mark">
          <h2>3. 腾讯与安阳牵手带来解法</h2>
        </div>
        <p>如何将最前沿的数字技术应用到文化遗产保护领域，是腾讯一直在思考的问题。在今年年初，河南省人民政府与腾讯签署战略合作协议，联合研究如何让文化遗产活起来，让中原文化得以更生动地呈现。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news28.jpeg"/>
          </div>
        </div>
        <p>
          为突破甲骨文“破译”与传承活化的难题，12月10日，
          <span class="mark-text">腾讯SSV数字文化实验室、腾讯优图实验室与甲骨文的故乡、世界文化遗产殷墟所在地安阳携手，共建甲骨文开放创新平台，</span>
          用新一代数字科技助力甲骨文考释研究与传承活化，以可持续社会价值创新的方式实现“科技+甲骨文”的共创共益，融合智能化、网络化、数字化的科技理念实现甲骨文考释研究、展示传承、活化利用的模式转型升级。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news28_1.png"/>
          </div>
        </div>
        <p>在项目启动会上，河南省文化和旅游厅党组书记、厅长姜继鼎表示，借助现代科技手段，进一步推动甲骨文考释研究、展示传承、活化利用的转型升级，用数字科技弘扬中华优秀传统文化，为安阳打造“中华字都”，建设国际旅游目的地，推进文旅文创融合战略发展，融入“行走河南、读懂中国”文化品牌作出贡献。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news28_2.png"/>
          </div>
        </div>
        <p>
          河南省安阳市委常委、宣传部部长薛崇林表示，
          <span class="mark-text">安阳与腾讯公司建立人机协同助力甲骨文“破译”和传承活化的专项合作，以可持续社会价值创新的方式实现“科技+甲骨文”的共创共益，</span>
          运用多种科技理念实现甲骨文研究、展示、传承的模式转型升级，是深入贯彻落实党的二十大精神和习近平总书记关于甲骨文指示批示精神的重要举措，也将开启新一代数字科技助力甲骨文活化利用的新篇章。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news28_3.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text">腾讯云副总裁、腾讯云智能负责人、腾讯优图实验室负责人吴运声表示，</span>
          我们计划基于“殷契文渊”平台，利用丰富的甲骨文拓片、摹本、著录甚至甲骨实物等数据，研发字形匹配、摹本生成、甲骨缀合、三维建模等系列算法，面向甲骨文领域的专家学者形成甲骨文智能搜索工具箱，实现专家学者与智能工具的人机协同，推动研究提质增效。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news28_4.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text">腾讯 SSV 数字文化实验室负责人舒展表示，</span>
          通过“科技+甲骨文”的深度共创，破解甲骨文考释研究过程的字形匹配难题和冷门绝学吸引公众参与难题，助力形成甲骨文考释研究的人机协同模式、展示传承的参与众创模式、活化利用的开放创新模式，守护汉字，让文化遗产活起来。
        </p>
        <div class="news-content-mark">
          <p>● “人机协同”模式助力甲骨文“破译”</p>
        </div>
        <p>
          基于“殷契文渊”及甲骨文的字形、摹本、著录等数据，研发字形匹配、摹本生成、甲骨缀合、三维建模等系列算法；
          <span class="mark-text">面向专家学者形成甲骨文智能搜索工具箱，</span>
          实现专家学者与智能工具的人机协同，为甲骨文考释研究提质增效，大幅加速未识甲骨字的破译。
        </p>
        <div class="news-content-mark">
          <p>● 互联网触达公众，吸引爱好者“参与众创”</p>
        </div>
        <p>
          <span class="mark-text">构建甲骨文传承小程序，</span>
          通过故事性引入、游戏化互动、社交化分享等方式吸引公众了解甲骨文及汉字的演变，通过有文字临摹、角色扮演、甲骨考古等功能，吸引公众常来体验。培育爱好者了解甲骨文考释方法和汉字构造方法，通过创意互动承担甲骨文专家学者已经分解的简单任务，形成甲骨文研究与传承双向互动的参与众创模式。
        </p>
        <div class="news-content-mark">
          <p>● 沉淀数字能力，体系化助力甲骨文活化利用的“开放创新”</p>
        </div>
        <p>
          <span class="mark-text">形成面向甲骨文物的三维建模工具、数据标准规范，面向国内和海外征集甲骨文物建模数据，</span>
          在数字空间保护甲骨文物；守护汉字，形成甲骨文虚拟键盘和汉字百科，为甲骨文活化利用提供基础支撑；参与“文化遗产数字助力计划”，围绕甲骨文及汉字、殷墟世界文化遗产等进行开放素材库建设，支撑在线展示和数字直播，进行版权保护及IP文创探索。
        </p>
        <div class="end-divide"></div>
        <p>往昔殷商，青铜时代，甲骨传文；今朝中华，数字时代，网络释字；跨越时空，文化传承，古今对话。“人机协同”共同加速甲骨文“破译”与活化利用，助力“中华字都”建设，用新一代数字科技弘扬中华优秀传统文化。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News23',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News28.vue